// This file is autogenerated!
// Do not edit manually!
// All changes will be overwritten by package-sync.ts

export const getVersion = (): string => {
  return '1.62.0';
};
